export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';

export default class extends Component {
    static template = template;

    static defaults() {
        return {
            positions: ['topRight', 'topLeft', 'bottomRight', 'bottomLeft', 'top', 'bottom'] as const
        }
    }

    showNotification(position: 'topRight' | 'topLeft' | 'bottomRight' | 'bottomLeft' | 'top' | 'bottom') {
        Notification.info({
            title: '通知标题',
            content: `通知出现在${position}位置`,
            position
        });
    }
}